import { render, staticRenderFns } from "./LeadOferta.vue?vue&type=template&id=a71d741e&scoped=true&lang=pug"
import script from "./LeadOferta.vue?vue&type=script&lang=js"
export * from "./LeadOferta.vue?vue&type=script&lang=js"
import style0 from "./LeadOferta.vue?vue&type=style&index=0&id=a71d741e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71d741e",
  null
  
)

export default component.exports